<template>
<div>
    <v-row v-if="loading">
      <v-col md="12" v-for="number in 3" :key="'loader-' + number">
        <v-skeleton-loader
          class="mx-auto"
          type="card"
          height="100"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col>
        <v-card flat>
          <v-toolbar dense flat>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="agregarSesion = true"
              >Agregar sesión</v-btn
            >
          </v-toolbar>
        </v-card>
      </v-col>
     
      <v-container>
        <v-card-title>
          <v-spacer></v-spacer>
          
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :items="sesionesFiltradas"
          class="mx-3"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 30, 40, -1],
            itemsPerPageAllText: 'Todos',
            itemsPerPageText: 'Elementos por página',
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <v-col cols="12" v-for="(sesion, index) in items" :key="`sesion-${index}`">
                <v-row>
                  <v-col >
                    <sesionItemComponent :sesion="sesion" />
                  </v-col>
                  
                </v-row>
                </v-col>
            </tbody>  
          </template>
        </v-data-table>
      </v-container>

      <agregarSesionComponent
        v-if="agregarSesion"
        :mostrar="agregarSesion"
        @cancelar="agregarSesion = false"
        @sesionAgregada="sesionAgregada"
      />
    </v-row>
</div>
</template>

<script>
import { mapGetters } from "vuex";

import agregarSesionComponent from "./agregarSesion.vue";
import sesionItemComponent from "./sesionItem.vue";
import { getSesionesService } from "./administrar.service";

export default {
  name: "administrarComponent",
  components: { sesionItemComponent, agregarSesionComponent },
  computed: {
    ...mapGetters(["userAdmin"]),
    sesionesFiltradas() {
      if (!this.search) {
        return this.sesiones;
      } else
      {
        const searchTerm = this.search.toLowerCase();
        return this.sesiones.filter(sesion => {
          return sesion.nombre.toLowerCase().includes(searchTerm);
        });
      }
    },
  },
  data() {
    return {
      loading: false,
      agregarSesion: false,
      search: "",
      sesiones: [],
    };
  },
  mounted() {
    if (!this.userAdmin) this.$router.push("/sesiones");
    else this.cargarSesiones();
  },
  methods: {
    async cargarSesiones() {
      try {
        this.loading = true;
        const serverResponse = await getSesionesService();
        this.loading = false;
        this.$validateResponse(serverResponse);
        if (!serverResponse.ok) {
          this.$notificarError(serverResponse.mensaje);
        } else {
          this.sesiones = serverResponse.sesiones;
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
    sesionAgregada(data) {
      this.sesiones.unshift(data.sesion);
      this.agregarSesion = false;
    }
  },
};
</script>